import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import permission from '~/skills/permission';
import {
  Select,
  MenuItem,
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage } from '@mui/icons-material';
import { EAA_TitleText } from '~/components/EditAndAddItem';

import { T_TitleCell, T_Btn_Function, T_TableRow } from '~/components/TableItem';
import { S_Input, S_Btn_Search, S_Btn_Add, S_Select, S_Title } from '~/components/SearchItem';

import T_common from '~/components/TableItem/common';
import CheckDelete from '~/components/Dialog/CheckDelete';
import PageTitle from '~/components/PageTitle';
import AddAndEdit from './AddAndEdit';

class Page_Extend extends Component {
  state={
    proj_item: '',
    proj_stage: '',
    proj_stages: [],
    per_page: 10,
    page: 1,

    sort: true,
    sort_field: 'upd_time',
    view_checkDelete: false,
    view_addAndEdit: false,
    mode_addAndEdit: '',
    currentId: '',
    currentAct: '',
  }

  componentDidMount () {
    const { proj_item, proj_stage } = this.state;
    const queryParams = new URLSearchParams(this.props.location.search);
    this.data = { proj_item, proj_stage };
    this.props.getPPPlanProjectListV2();
    this.refresh();
    const ppId = queryParams.get('id');
    const assignedWindcontractId = queryParams.get('contractId');

    if (ppId || assignedWindcontractId) {
      localStorage.setItem('Wind_ID', assignedWindcontractId);
      this.setState({ currentId: ppId, view_addAndEdit: true, mode_addAndEdit: 'edit' });
    }
  }

  refresh=() => {
    const { page, per_page, sort, sort_field } = this.state;
    const { proj_item, proj_stage } = this.data;
    this.props.getProjectProgressList({
      page,
      per_page,
      body: {
        proj_item,
        proj_stage,
        sort: sort ? 'desc' : 'asc',
        sort_field,
      },
    });
  }

  search=() => this.setState({ page: 1 }, () => this.refresh());

  _click_search=() => {
    const { proj_item, proj_stage } = this.state;
    this.data = { proj_item, proj_stage };
    this.search();
  }

  _delete=(id, act) => this.setState({ currentId: id, currentAct: act, view_checkDelete: true })
  _close_view_checkDelete=() => {
    // this.refresh();
    this.setState({ currentId: '', currentAct: '', view_checkDelete: false });
  }

  _add=() => this.setState({ view_addAndEdit: true, mode_addAndEdit: 'add' })
  _view=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'view' })
  _edit=id => this.setState({ currentId: id, view_addAndEdit: true, mode_addAndEdit: 'edit' })
  _close_view_addAndEdit=() => {
    this.refresh();
    this.setState({ currentId: '', view_addAndEdit: false, mode_addAndEdit: '' });
  }

  toolBar=() => {
    const { PPPlanProjectList } = this.props;
    const PlanProjectItems = PPPlanProjectList?.items || [];
    const { proj_item, proj_stage, proj_stages } = this.state;

    const handleItemSelected = (item_name) => {
      const item = PlanProjectItems.find(element => element.name === item_name) || {};
      const { stages = [] } = item;
      console.log('item', item);
      this.setState({ proj_stages: stages });
    };

    return (
      <div style={{ marginTop: 24, display: 'flex' }}>
        <div>
          <S_Title text='項目' />
          <S_Select list={PlanProjectItems} value={proj_item} onChange={d => {
            handleItemSelected(d);
            this.setState({ proj_item: d });
          }} />
        </div>
        <div style={{ marginLeft: 16 }}>
          <S_Title text='階段' />
          {
            proj_stages.length > 0 ? (
              <S_Select list={proj_stages} value={proj_stage} onChange={d => this.setState({ proj_stage: d })} />
            ) : (
              <EAA_TitleText width={120} fontSize={18} text='無需點選階段' />
            )
          }
        </div>
        <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
          <S_Btn_Search onClick={this._click_search} />
        </div>
      </div>
    );
  }

  toolBar2=() => (
    <div style={{ marginTop: 24, display: 'flex', alignItems: 'center' }}>
      <div style={{ color: '#064B6F', fontSize: 20, lineHeight: '24px', letterSpacing: '0.25%' }}>工程進度清單</div>
      <S_Btn_Add onClick={this._add} style={{ marginLeft: 24 }} disabled={!this.props.canAdd} />
    </div>
  )

  renderTableTitle=() => {
    const { sort, sort_field } = this.state;
    const onChangeSort = t => {
      this.setState({ sort_field: t, sort: sort_field === t ? !sort : false }, () => this.search());
    };
    const ary = [
      { name: '序號' },
      { name: '項目', id: 'proj_item' },
      { name: '階段', id: 'proj_stage' },
      { name: '製造國家', id: 'nation_made' },
      { name: '製造廠商', id: 'company_made' },
      { name: '數量', id: '' },
      { name: '起始日期', id: 'plan_start_date' },
      { name: '完成日期', id: 'plan_end_date' },
      { name: '已完成數量', id: 'total_allnum' },
      { name: '已完成百分比' },
      { name: '資料(主管)送出時間', id: 'upd_time' },
      { name: '功能' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
              arrow={!!o.id}
              bol={sort_field === o.id ? sort : true}
              onClick={() => onChangeSort(o.id)}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { ProjectProgressList = {}, canEdit, canDel, sign: { role_level = 1 } = {} } = this.props;
    const { list = [], page = 0, total = 0, per_page = 0 } = ProjectProgressList;
    const cellStyle = { fontSize: 14 };
    const checkCanEdit = (form_status, admin_status) => {
      const formStatus = Number(form_status);
      const adminStatus = Number(admin_status);
      const roleLevel = Number(role_level);
    
      if (!canEdit) return false;
    
      switch (roleLevel) {
        case 1:
          return formStatus < 2;
    
        case 2:
          return formStatus >= 2 && formStatus < 3;
    
        case 3:
          return formStatus === 3 && adminStatus === 1;
    
        default:
          return false;
      }
    };


    let start = 0;
    if (page > 0) {
      start = (page - 1) * per_page + 1;
      if (start > total)start = 0;
    }
    return (
      <TableBody>
        {list.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>{i + start}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.proj_item}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.proj_stage}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.nation_made}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.company_made}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.e}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.plan_start_date}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.plan_end_date}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.total_allnum}</TableCell>
            <TableCell align='center' style={cellStyle}>{`${(100 * o.total_allnum / o.plan_allnum).toFixed(0)}%`}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.upd_time}</TableCell>
            <TableCell style={{ width: 214 }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                <T_Btn_Function text='檢視' backgroundColor={T_common.type1} onClick={() => this._view(o.id)} />
                {
                  checkCanEdit(o.form_status, o.admin_status) &&
                  <T_Btn_Function text='編輯' backgroundColor={T_common.type2} onClick={() => this._edit(o.id)} style={{ marginLeft: 8, marginRight: 8 }} disabled={!checkCanEdit(o.form_status, o.admin_status)} />
                }
                {
                  !checkCanEdit(o.form_status, o.admin_status) && <div style={{ marginLeft: 5, marginRight: 5 }}></div>
                }
                {
                  canDel &&
                  <T_Btn_Function text='刪除' backgroundColor={T_common.type3} onClick={() => this._delete(o.id, o.proj_item)} disabled={!canDel} />
                }
              </div>
            </TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTableBar=() => {
    const { ProjectProgressList = {} } = this.props;
    const { has_next = false, has_prev = false, page = 0, pages = 0, total = 0 } = ProjectProgressList;
    const { per_page, page: statePage } = this.state;
    const returnPages = () => {
      const array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      return array;
    };
    const returnPers = () => [10, 20, 30, 40];
    const canFirst = page > 1;
    const canLast = page < pages;
    return (
      <div style={{ height: 48, display: 'flex', alignItems: 'center', width: '98%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
        <div style={{ flex: 1 }} />
        <FirstPage style={{ height: 24, width: 24, color: canFirst ? 'black' : 'gray', cursor: canFirst ? 'pointer' : 'default' }} onClick={() => { if (canFirst) this.setState({ page: 1 }, () => this.refresh()); }} />
        <ArrowBackIos style={{ marginLeft: 3, marginRight: 5, height: 16, width: 16, color: has_prev ? 'black' : 'gray', cursor: has_prev ? 'pointer' : 'default' }} onClick={() => { if (has_prev) this.setState({ page: this.state.page - 1 }, () => this.refresh()); }} />
        <div style={{ fontSize: 14 }}>第</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px', marginRight: 8, marginLeft: 8 }}
          variant="outlined"
          value={statePage}
          onChange={e => this.setState({ page: e.target.value }, () => { this.refresh(); })}
        >
          {returnPages().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginRight: 8 }}>{`/${pages} 頁，每頁`}</div>
        <Select
          style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px' }}
          variant="outlined"
          value={per_page}
          onChange={e => this.setState({ per_page: e.target.value }, () => { this.search(); })}
        >
          {returnPers().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
        </Select>
        <div style={{ fontSize: 14, marginLeft: 8 }}>{`筆，共${total}筆`}</div>
        <ArrowForwardIos style={{ marginLeft: 5, height: 16, width: 16, color: has_next ? 'black' : 'gray', cursor: has_next ? 'pointer' : 'default' }} onClick={() => { if (has_next) this.setState({ page: this.state.page + 1 }, () => this.refresh()); }} />
        <LastPage style={{ marginRight: 19, height: 24, width: 24, color: canLast ? 'black' : 'gray', cursor: canLast ? 'pointer' : 'default' }} onClick={() => { if (canLast) this.setState({ page: pages }, () => this.refresh()); }} />
        <div style={{ flex: 1 }} />
      </div>
    );
  }

  renderTable=() => {
    const { ProjectProgressList = {} } = this.props;
    const { list = [] } = ProjectProgressList;
    const haveData = list.length > 0;
    return (
      <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
        <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  renderMainPage=() => {
    const { deleteProjectProgress, ProjectProgressList = {} } = this.props;
    const { currentId, view_checkDelete, currentAct } = this.state;
    const { list = [] } = ProjectProgressList;
    const haveData = list.length > 0;
    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text='各工程進度' />
        {this.toolBar()}
        {this.toolBar2()}
        {this.renderTable()}
        {haveData && this.renderTableBar()}
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        <CheckDelete
          open={view_checkDelete}
          text={`項目：${currentAct}`}
          onClose={this._close_view_checkDelete}
          search={this.search}
          resKey='DeleteProjectProgress'
          onDelete={() => { deleteProjectProgress(currentId); }}
        />
      </div>
    );
  }

  render () {
    const { currentId, view_addAndEdit, mode_addAndEdit } = this.state;
    return !view_addAndEdit
      ? this.renderMainPage()
      : <AddAndEdit id={currentId} mode={mode_addAndEdit} _onClose={this._close_view_addAndEdit} />;
  }
}
const mapStateToProps = state => ({
  sign: state.data?.AtyFunction,
  PPPlanProjectList: state.data?.PPPlanProjectListV2 || {},
  ProjectProgressList: state.data?.ProjectProgressList || {},
  ...permission.returnPermission(state),
});
const mapDispatchToProps = dispatch => ({
  getPPPlanProjectListV2: () => Actions_Wind.getPPPlanProjectListV2(dispatch),
  getProjectProgressList: body => Actions_Wind.getProjectProgressList(dispatch, body),
  deleteProjectProgress: id => Actions_Wind.deleteProjectProgress(dispatch, { id }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page_Extend);
